import { ProductTemplateConfigType } from './ProductTemplate';
import { Message } from 'dg-web-shared/lib/Localized.ts';

export const enum ProductTemplateUseCase {
    ALL_ACCESS = 'ALL_ACCESS',
    CALENDAR_DAY_RESERVATION = 'CALENDAR_DAY_RESERVATION',
    CUSTOMER_EXTERNAL = 'CUSTOMER_EXTERNAL',
    EVENT = 'EVENT',
    GUEST_PERMIT_VALID_TO = 'GUEST_PERMIT_VALID_TO',
    GUEST_RESERVATION = 'GUEST_RESERVATION',
    GUEST_RESERVATION_UBS = 'GUEST_RESERVATION_UBS',
    GUEST_DAY_PASS = 'GUEST_DAY_PASS',
    PERMIT_FIXED_DURATION = 'PERMIT_FIXED_DURATION',
    PERMIT_UNTIL_REVOCATION = 'PERMIT_UNTIL_REVOCATION',
    PERMIT_VALID_TO = 'PERMIT_VALID_TO',
    SUBSCRIPTION = 'SUBSCRIPTION',
}

export function deriveUseCaseFromConfigType(
    configType: ProductTemplateConfigType,
): ProductTemplateUseCase {
    switch (configType) {
        case ProductTemplateConfigType.ALL_ACCESS:
            return ProductTemplateUseCase.ALL_ACCESS;

        case ProductTemplateConfigType.CALENDAR_DAY_RESERVATION:
            return ProductTemplateUseCase.CALENDAR_DAY_RESERVATION;

        case ProductTemplateConfigType.CUSTOMER_EXTERNAL:
            return ProductTemplateUseCase.CUSTOMER_EXTERNAL;

        case ProductTemplateConfigType.EVENT:
            return ProductTemplateUseCase.EVENT;

        case ProductTemplateConfigType.GUEST_PERMIT_VALID_TO:
            return ProductTemplateUseCase.GUEST_PERMIT_VALID_TO;

        case ProductTemplateConfigType.GUEST_RESERVATION:
            return ProductTemplateUseCase.GUEST_RESERVATION;

        case ProductTemplateConfigType.GUEST_RESERVATION_UBS:
            return ProductTemplateUseCase.GUEST_RESERVATION_UBS;

        case ProductTemplateConfigType.GUEST_DAY_PASS:
            return ProductTemplateUseCase.GUEST_DAY_PASS;

        case ProductTemplateConfigType.PERMIT_FREE_FIXED_DURATION:
            return ProductTemplateUseCase.PERMIT_FIXED_DURATION;

        case ProductTemplateConfigType.PERMIT_FREE_VALID_TO:
            return ProductTemplateUseCase.PERMIT_VALID_TO;

        case ProductTemplateConfigType.PERMIT_UNTIL_REVOCATION:
            return ProductTemplateUseCase.PERMIT_UNTIL_REVOCATION;

        case ProductTemplateConfigType.SUBSCRIPTION:
            return ProductTemplateUseCase.SUBSCRIPTION;
    }
}

export function useCaseNameFromConfigType(
    configType: ProductTemplateConfigType,
): Message {
    return nameOfProductTemplateUseCase(
        deriveUseCaseFromConfigType(configType),
    );
}

export function nameOfProductTemplateUseCase(
    useCase: ProductTemplateUseCase,
): Message {
    switch (useCase) {
        case ProductTemplateUseCase.PERMIT_UNTIL_REVOCATION:
            return {
                de: 'Gratis-Bewilligung bis auf Widerruf',
                fr: "Autorisation gratuite jusqu'à révocation",
                it: 'Autorizzazione gratuita fino a revoca',
                en: 'Free permit until revocation',
            };
        case ProductTemplateUseCase.PERMIT_FIXED_DURATION:
            return {
                de: 'Gratis-Bewilligung mit fester Dauer',
                fr: 'Autorisation gratuite à durée fixe',
                it: 'Autorizzazione gratuita con durata fissa',
                en: 'Free permit with fixed duration',
            };
        case ProductTemplateUseCase.SUBSCRIPTION:
            return {
                de: 'Abonnement',
                fr: 'Abonnement',
                it: 'Abbonamento',
                en: 'Subscription',
            };
        case ProductTemplateUseCase.CALENDAR_DAY_RESERVATION:
            return {
                de: 'Kalendertagsreservation',
                fr: 'Réservation journée de calendrier',
                it: 'Prenotazione giorno di calendario',
                en: 'Calendar day reservation',
            };
        case ProductTemplateUseCase.GUEST_RESERVATION_UBS:
            return {
                de: 'Gäste Reservation',
                fr: 'Réservations clients',
                it: 'Prenotazioni degli ospiti',
                en: 'Guest reservations',
            };
        case ProductTemplateUseCase.ALL_ACCESS:
            return {
                de: 'Passepartout',
                fr: 'Passepartout',
                it: 'Passepartout',
                en: 'Passepartout',
            };
        case ProductTemplateUseCase.GUEST_PERMIT_VALID_TO:
            return {
                de: 'Gastkarte',
                fr: "Carte d'hôte",
                it: 'Carta ospite',
                en: 'Guest card',
            };
        case ProductTemplateUseCase.GUEST_RESERVATION:
            return {
                de: 'Gastbewilligung',
                fr: 'Autorisation hôte',
                it: 'Autorizzazione ospite',
                en: 'Guest permit',
            };
        case ProductTemplateUseCase.CUSTOMER_EXTERNAL:
            return {
                de: 'Externer Kunde',
                fr: 'Client externe',
                it: 'Cliente esterno',
                en: 'External customer',
            };
        case ProductTemplateUseCase.EVENT:
            return {
                de: 'Veranstaltung',
                fr: 'Manifestation',
                it: 'Evento',
                en: 'Event',
            };
        case ProductTemplateUseCase.PERMIT_VALID_TO:
            return {
                de: 'Gratis-Bewilligung mit Enddatum',
                fr: 'Autorisation gratuite avec date de fin',
                it: 'Autorizzazione gratuita con data di fine',
                en: 'Free permit with end date',
            };
        case ProductTemplateUseCase.GUEST_DAY_PASS:
            return {
                de: 'Gast-Tagespass',
                fr: 'Pass journalier hôtes',
                it: 'Pass giornaliero ospiti',
                en: 'Guest day pass',
            };
    }
}
